import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDyS884qZHCJ7vkGrWKCXGhyMceivHnTbU",
  authDomain: "comic-mania-56481.firebaseapp.com",
  projectId: "comic-mania-56481",
  storageBucket: "comic-mania-56481.appspot.com",
  messagingSenderId: "652516597738",
  appId: "1:652516597738:web:e25e58ef96968e5e175c93"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export default auth;